/* angular:styles/component:scss;6e122533cdf268b4253cb095eeffd790f55d3d28bd751b78d8277bcc5ac4d879;/home/vsts/work/1/s/Autocare.Api/ClientApp/src/app/Formly/custom-types/custom-file-picker.component.ts */
.top {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
#click {
  color: var(--Brand-700, #d47500);
}
.svg {
  color: var(--Gray-600, #475467);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
.file-upload {
  border: 2px dashed #e4e7ec;
  padding:
    20px,
    28px,
    20px,
    28px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease, height 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  width: 464px;
  min-height: 120px;
  height: auto;
}
.file-upload.file-selected {
  min-height: 100px;
  padding: 20px;
}
.file-upload-hover {
  border-color: #ff9f2a;
}
.file-details {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.file-info {
  flex-grow: 1;
  margin-left: 10px;
}
.file-name {
  font-size: 14px;
  font-weight: 600;
  color: #344054;
}
.file-size {
  display: block;
  font-size: 12px;
  color: #666;
}
.remove-button {
  background: none;
  border: none;
  cursor: pointer;
}
.progress-container {
  width: 100%;
  background-color: #f1f1f1;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  height: 10px;
  margin-top: 10px;
}
.progress-bar {
  background-color: #ff8c00;
  height: 100%;
  transition: width 0.3s ease;
}
.progress-text {
  position: absolute;
  right: 10px;
  top: -20px;
  font-size: 12px;
  color: #344054;
}
/*# sourceMappingURL=custom-file-picker.component-CLUPO2CY.css.map */
